export default "__VITE_ASSET__2IQCi6r3__"